export default __webpack_public_path__ + "static/media/helm1.984d5946.jpg";